import { Component, OnDestroy, OnInit } from '@angular/core';
import { ServiceBagServices } from '@base/component/ServiceBag';
import { ClientException } from '@base/entities/BaseEntities';
import { SysGlobals } from '../framework/sysglobals';
import { AppConfigService } from '../../configuration/app.config.service';
import { ActivatedRoute } from '@angular/router';
import { EnumApplicationMode } from '../framework/sysenums.enum';
import { RC } from '../framework/resources.service';
import { Subscription } from 'rxjs';
import { FrameworkService } from '../framework/framework.service';

@Component({
    providers: ServiceBagServices,
    selector: 'm4u-exception',
    templateUrl: './exception.component.html',
    styleUrls: ['./exception.component.scss']
})
export class ExceptionComponent implements OnInit, OnDestroy {
    private subscription: Subscription;

    constructor(
        private appConfigService: AppConfigService,
        private activatedRoute: ActivatedRoute,
        private frameworkService: FrameworkService) {
    }

    ngOnInit() {
        this.subscription = this.activatedRoute.data.subscribe(data => {
            if (data && data.MessageCode) {
                const exception = new ClientException;
                exception.Message = RC(data.MessageCode);
                SysGlobals.LastException = exception;
            }
        });
    }

    ngOnDestroy(): void {
        this.subscription && this.subscription.unsubscribe();
    }

    GetButtonText() {
        return this.appConfigService.AppConfig.Mode === EnumApplicationMode.Standard
            ? RC('btnReEntry')
            : RC('btnReload');
    }

    OnReload() {
        if (this.appConfigService.AppConfig.Mode === EnumApplicationMode.Standard) {
            this.frameworkService.NavigateDefault();
            return;
        }
        //For SiglePage and IFrame modes reload application
        //Application path was taken from 'unsupported-browsers' script that sets path on the application start
        window.location.href = window['applicationPath'];
    }

    E(): ClientException {
        return SysGlobals.LastException;
    }
}
